import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ClientContactSelect from './ClientContactSelect';
import { fetchClientContacts } from 'store/client/clientActions';
import withLoader from 'components/Shared/withLoader';

const ClientContactSelectWithLoader = withLoader(ClientContactSelect);

class ClientContactSelectContainer extends React.Component {
    constructor(props) {
        super(props);

        if (props.clientId !== 0) {
            fetchClientContacts(props.clientId);
        }
    }

    componentDidUpdate(prevProps) {
        const { fetchClientContacts, clientId, chargerContact } = this.props;

        if (clientId !== prevProps.clientId && chargerContact) {
            fetchClientContacts(clientId);
        }
    }

    handleChangeClientContact = (event) => {
        const { clientContacts, onChangeClientContact } = this.props;
        const value = event.target.value;

        // On recherche le contact.
        const contact = clientContacts.find(x => x.id === value);

        if (contact !== undefined) {
            let nomComplet = '';
            if (contact.nom !== null && contact.nom !== undefined) {
                if (contact.prenom !== null && contact.prenom !== undefined) {
                    nomComplet = contact.nom + ' ' + contact.prenom;
                } else {
                    nomComplet = contact.nom;
                }
            } else {
                if (contact.prenom !== null && contact.prenom !== undefined) {
                    nomComplet = contact.prenom;
                }
            }

            onChangeClientContact(value, nomComplet, contact.email, contact.telephonePortable);
        } else {
            onChangeClientContact(0, '', '', '');
        }
    }

    render() {
        const { selectedId, clientContacts, isLoading, clientId, chargerContact, chargerContactExclusionMotif } = this.props;

        return (
            <ClientContactSelectWithLoader
                value={selectedId}
                contacts={clientContacts}
                onChangeClientContact={this.handleChangeClientContact}
                isLoading={isLoading}
                chargementExclu={clientId !== 0 && !chargerContact}
                chargerContactExclusionMotif={chargerContactExclusionMotif}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    clientId: state.client[ownProps.namespace].suggestions.selectedId,
    chargerContact: state.client[ownProps.namespace].suggestions.chargerContact,
    chargerContactExclusionMotif: state.client[ownProps.namespace].suggestions.chargerContactExclusionMotif,
    clientContacts: state.client[ownProps.namespace].contacts.items,
    isLoading: state.client[ownProps.namespace].contacts.isLoading,
    selectedId: state.client[ownProps.namespace].contacts.selectedId
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchClientContacts: (clientId) => dispatch(fetchClientContacts(ownProps.namespace, clientId))
});

ClientContactSelectContainer.propTypes = {
    onChangeClientContact: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientContactSelectContainer);